import { render } from "./AcademicsMgt.vue?vue&type=template&id=3f95d46a&scoped=true"
import script from "./AcademicsMgt.vue?vue&type=script&lang=js"
export * from "./AcademicsMgt.vue?vue&type=script&lang=js"

import "./AcademicsMgt.vue?vue&type=style&index=0&id=3f95d46a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f95d46a"]])

export default __exports__